const IMAGE_NAME = /\.(jpe?g|png|gif|webp|heic|heif|bmp|avif)$/i;

/** iOS/PWA often send camera/library photos with an empty MIME type. */
export function isLikelyImageFile(file: File): boolean {
  if (file.type.startsWith('image/')) return true;
  if (file.type && file.type !== 'application/octet-stream') return false;
  if (!file.name || !file.name.includes('.')) return true;
  return IMAGE_NAME.test(file.name);
}
